











































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import AddDirectoryModal from '@/components/documents/AddDirectoryModal.vue';
import { Directories } from '@/@types/LibraryComponent';
import DocumentIcon from '@/components/documents/DocumentIcon.vue';

@Component({
  components: {
    AddDirectoryModal,
    DocumentIcon,
  },
})
export default class DirectoryCardList extends Vue {
  @Prop({ default: null })
  private directories!: Array<Directories>;

  @Prop({ default: null })
  private directoryCount!: number;

  private isOpenAddDirectoryModal: boolean = false;

  private defaultDirectoryCount: number = 11;
  private avatarSizeDocument: number = 140;
  private avatarColorDocument: string = '#edf4ff';
  private iconSizeDocument: number = 70;
  private iconColorDocument: string = '#4384f3';
  private paddingTop: string = 'padding-top';

  @Emit('onIsMore')
  private callIsMore(): void {}

  @Emit('onShowDocument')
  private callShowDocument(): void {}

  private closeAddDirectoryModal() {
    this.isOpenAddDirectoryModal = false;
  }
}
